export default __webpack_public_path__ + "static/media/boosty_79.3963e948.png";